import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";

import { Fieldset, Field, Control, Label } from "rbx";
import {
  UPDATE_NOTE_MUTATION,
  DELETE_NOTE_MUTATION
} from "../../graphql/Notes/Notes.graphql";
import {
  SystemCodeSelect,
  PoorTextEditor,
  EditFormButtonGroup
} from "../inputs";

import { ourToast as toast } from "../../utils";

import Section from "../Section";

class EditEmployeeNoteForm extends Component {
  state = {
    NoteTypeRecIdRef: "",
    Note: "",
    TableName: "Employees",
    ...this.props.note
  };

  onChange = evt => {
    this.setState({
      [evt.target.name]: evt.target.value
    });
  };

  render() {
    const { NoteTypeRecIdRef, Note, TableName } = this.state;
    const { onComplete, EmployeeRecIdRef } = this.props;

    return (
      <Mutation
        mutation={UPDATE_NOTE_MUTATION}
        refetchQueries={["ALL_NOTES_QUERY"]}
        variables={{
          data: {
            RefRecId: parseInt(EmployeeRecIdRef),
            NoteTypeRecIdRef: parseInt(NoteTypeRecIdRef),
            Note,
            TableName
          },
          where: {
            RecId: this.props.note.RecId
          }
        }}
      >
        {(updateNote, { loading, error }) => (
          <Section title="Edit Note">
            <form
              id="edit-employee-note"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await updateNote();
                  onComplete();
                  toast.success("Note updated successfully.");
                } catch (err) {
                  toast.error("Error updating Note.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <Field>
                  <Control>
                    <SystemCodeSelect
                      required
                      icon="globe"
                      label="Note Type"
                      lookup={{ Category: "Employee", Code: "EmployeeNote" }}
                      name="NoteTypeRecIdRef"
                      value={NoteTypeRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Label>Note</Label>
                  <Control>
                    <PoorTextEditor
                      name="Note"
                      value={Note}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <EditFormButtonGroup
                  deleteMutation={DELETE_NOTE_MUTATION}
                  form="edit-employee-note"
                  refetchQueries={["ALL_NOTES_QUERY"]}
                  variables={{ where: { RecId: this.props.note.RecId } }}
                  onComplete={onComplete}
                />
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

EditEmployeeNoteForm.propTypes = {
  EmployeeRecIdRef: PropTypes.string,
  onComplete: PropTypes.func,
  note: PropTypes.object
};
export default EditEmployeeNoteForm;
